module.exports = __webpack_public_path__ + "media/src/img/vk-icon-91dcfd4b7da64a50debfed719149f111.svg";